var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.53418 12.3506C0.533594 14.4511 1.08672 16.5021 2.13848 18.3098L0.433594 24.4864L6.80391 22.829C8.56585 23.7808 10.54 24.2795 12.5461 24.2796H12.5514C19.1739 24.2796 24.5648 18.9324 24.5677 12.36C24.5689 9.17525 23.3201 6.18048 21.0512 3.92738C18.7826 1.67447 15.7655 0.433094 12.5509 0.431641C5.92754 0.431641 0.537012 5.77854 0.534277 12.3506",
    fill: "url(#paint0_linear_608_2654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.104492 12.3465C0.103809 14.5226 0.676758 16.6469 1.76602 18.5194L0 24.9173L6.59873 23.2006C8.41689 24.1842 10.464 24.7028 12.547 24.7036H12.5523C19.4125 24.7036 24.9971 19.1641 25 12.3564C25.0012 9.05717 23.7074 5.95475 21.3574 3.62093C19.0071 1.2874 15.8821 0.00135659 12.5523 0C5.69101 0 0.107227 5.53876 0.104492 12.3465ZM4.03418 18.1969L3.78779 17.8088C2.75205 16.1747 2.20537 14.2863 2.20615 12.3473C2.2084 6.68886 6.84941 2.08527 12.5563 2.08527C15.3199 2.08643 17.9172 3.15543 19.8707 5.09496C21.8241 7.03469 22.899 9.61318 22.8983 12.3556C22.8958 18.0141 18.2547 22.6182 12.5523 22.6182H12.5482C10.6915 22.6172 8.87051 22.1225 7.28242 21.1875L6.90449 20.9651L2.98867 21.9838L4.03418 18.1968V18.1969Z",
    fill: "url(#paint1_linear_608_2654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44043 7.18495C9.20742 6.67109 8.96221 6.66072 8.74063 6.65171C8.55918 6.64396 8.35176 6.64454 8.14453 6.64454C7.93711 6.64454 7.6001 6.72196 7.31523 7.03059C7.03008 7.3395 6.22656 8.08601 6.22656 9.60433C6.22656 11.1227 7.34111 12.5901 7.49648 12.7962C7.65205 13.0019 9.64814 16.2174 12.8095 17.4544C15.4368 18.4824 15.9715 18.278 16.5417 18.2264C17.112 18.1751 18.3819 17.4801 18.641 16.7595C18.9003 16.0389 18.9003 15.4213 18.8226 15.2922C18.7448 15.1636 18.5374 15.0864 18.2264 14.9321C17.9152 14.7778 16.3861 14.0312 16.1011 13.9282C15.8159 13.8253 15.6086 13.7739 15.4012 14.0829C15.1938 14.3914 14.5981 15.0864 14.4166 15.2922C14.2353 15.4985 14.0537 15.5242 13.7428 15.3698C13.4315 15.215 12.4299 14.8895 11.2415 13.8382C10.3169 13.0202 9.69268 12.01 9.51123 11.701C9.32979 11.3925 9.4918 11.2253 9.64775 11.0715C9.7875 10.9332 9.95889 10.7111 10.1146 10.531C10.2696 10.3507 10.3214 10.2222 10.4251 10.0163C10.5289 9.81034 10.477 9.6301 10.3993 9.47574C10.3214 9.32138 9.71699 7.79512 9.44043 7.18495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_608_2654",
    x1: 1207.14,
    y1: 2405.91,
    x2: 1207.14,
    y2: 0.431641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_608_2654",
    x1: 1250,
    y1: 2491.73,
    x2: 1250,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_2654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon_whatsapp.c951826941dd9c092f1c7c9d61c4b29d.svg";
export { ForwardRef as ReactComponent };